<template>
  <div>
    <div style="font-size: 22px" class="pl-4 mt-4">
      สำนักงานส่งเสริมเศรษฐกิจดิจิทัลเขตพื้นที่ภาคเหนือ สาขาภาคเหนือตอนล่าง
    </div>
    <v-divider></v-divider>
    <div class="pa-5">
      <v-row dense>
        <v-col cols="2">
          <v-icon size="30px">mdi-map-marker-outline</v-icon>
        </v-col>
        <v-col cols="10">
          <div class="pl-0">
            อาคารเอกาทศรถ ชั้น 1 มหาวิทยาลัยนเรศวร เลขที่ 99 ต.ท่าโพธิ์ อ.เมือง
            จ.พิษณุโลก 65000
          </div>
          <div class="mt-4">
            <div>Tel : 08-6431-2165</div>
            <!-- <div>Fax : (+66) 0-5324-7282</div> -->
          </div>
          <div class="mt-4">
            <!-- <div>Email : Doss@depa.or.th</div> -->
          </div>
        </v-col>
      </v-row>
      <div
        class="mt-6"
        style="position: relative; width: 100%; height: 0; padding-top: 100%"
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3820.638165343972!2d100.19053035939086!3d16.744896419795786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf04fb558f3130f0!2z4Lih4Lir4Liy4Lin4Li04LiX4Lii4Liy4Lil4Lix4Lii4LiZ4LmA4Lij4Lio4Lin4Lij!5e0!3m2!1sth!2sus!4v1617784864209!5m2!1sth!2sus"
          style="
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
          "
          frameborder="0"
          allowfullscreen=""
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>